/*
 * @Author: your name
 * @Date: 2022-01-12 10:44:24
 * @LastEditTime: 2022-01-12 11:50:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\store\reducer.js
 */
import { GET_EARID } from "./constants";

function reducer(state, action) {
  switch (action.type) {
    case GET_EARID:
      return action.earList;

    default:
      return [];
  }
}

export default reducer;
